var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 9.99996L9.33317 13.3333L14.6665 6.66663M9.99984 19.3333C8.77417 19.3333 7.5605 19.0919 6.42813 18.6228C5.29575 18.1538 4.26685 17.4663 3.40017 16.5996C2.53349 15.7329 1.84601 14.704 1.37696 13.5717C0.907918 12.4393 0.666504 11.2256 0.666504 9.99996C0.666504 8.77429 0.907918 7.56062 1.37696 6.42825C1.84601 5.29588 2.53349 4.26698 3.40017 3.4003C4.26685 2.53362 5.29575 1.84613 6.42813 1.37708C7.5605 0.90804 8.77417 0.666626 9.99984 0.666626C12.4752 0.666626 14.8492 1.64996 16.5995 3.4003C18.3498 5.15064 19.3332 7.52461 19.3332 9.99996C19.3332 12.4753 18.3498 14.8493 16.5995 16.5996C14.8492 18.35 12.4752 19.3333 9.99984 19.3333Z",
    stroke: "#45894D",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_1590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.5bd8cf139905ecc5f99f55c928ca1faa.svg";
export { ForwardRef as ReactComponent };